/*
* Whitebox wrapper component for views
*/

import * as React from 'react';
import { Row } from 'react-bootstrap';

import { BootstrapColXl as Col } from './bootstrap/bootstrapcolxl';

export interface IWhiteBoxSectionProps {
    children?: any;
    title?: string;
    titleClassName?: string;
    titleColMd?: number;
    wrapperClassName?: string;
    titleRowClassName?: string;
    childrenWrapperClassName?: string;
}

export class WhiteBoxSection extends React.Component<IWhiteBoxSectionProps, any> {
    public static defaultProps = {
        title: '',
        // titleClassName: 'white-box-section-title box-title pull-left',
        titleClassName: 'white-box-section-title pull-left',
        titleColMd: 12,
        wrapperClassName: 'white-box-section',
        titleRowClassName: 'white-box-section-title-wrapper',
        childrenWrapperClassName: 'white-box-section-children-wrapper',
    };

    public constructor(props: IWhiteBoxSectionProps) {
        super(props);
    }

    public render() {
        const {
            children,
            title,
            titleClassName,
            titleColMd,
            wrapperClassName,
            titleRowClassName,
            childrenWrapperClassName,
        } = this.props;

        let titleRow;
        if (title) {
            titleRow = (
                <div className={titleRowClassName}>
                    <Row>
                        <Col xs={titleColMd}>
                            <span className={titleClassName}>{title}</span>
                        </Col>
                    </Row>
                </div>
            );
        }

        return (
            <div className={wrapperClassName}>
                {titleRow}
                <div className={childrenWrapperClassName}>
                    {children}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/whiteboxsection.tsx